export default {
  layers: {
    exhibition: 'Exhibitions Spaces',
    home: 'Exhibitors\' Addresses',
    birth: 'Exhibitors\' Birthplaces',
    death: 'Exhibitors\' Deathplaces',
    owner: 'Owners\' Addresses',
    creation: 'Artworks\' creation addresses'
  },
  message: {
    limit: 'The list displays the results per page, the map displays all the results within a limite of 3,000 items.'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en_GB/map.js